'use strict';

export default class ViewsTable {
  constructor() {
    var table = $('.views-table');
    if(table.length < 1) return;

    var fields = table.find('th.views-field a');
    if(fields.not(function() {
        if($(this).find('.tablesort').length) return;

        $(this).append('<span class="tablesort tablesort--none"></span>');
    })); 
    
  }
}
